import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { ProgressBar } from '../../../components/ProgressBar';
import { HeaderSlot, ShellContent } from '../../../components/Shell';
import { HideBotMenu } from '../../../components/Shell/HideBotMenu';
import {
  LOGBOOK_MAX_PAGE,
  useLogbookFormState,
  useLogbookPage,
  useSaveReportForLater,
} from '../../../services/logbook';
// import { DayOffAlert } from '../DayOffAlert/DayOffAlert';
import { Subscribe } from '@react-rxjs/core';
import { ErrorBoundary } from 'react-error-boundary';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../../components/Button';
import { Fallback } from '../../../components/Fallback/Fallback';
import { CloseButton } from '../../../components/Modal/CloseButton';
import { PlaceCenter } from '../../../components/PlaceCenter';
import { useVehicle } from '../../../services/vehicle';
import { LogbookFormPage } from './LogbookForm/LogbookForm';
import styles from './Report.module.css';
import { Signature } from './Signature';
import { Timeline } from './Timeline/Timeline';
import { ReportTitle } from './views';

export const Report: FC = () => {
  const navigate = useNavigate();
  const page = useLogbookPage();
  const state = useLogbookFormState();
  const { running } = useSaveReportForLater();

  return (
    <ShellContent full>
      <div className={styles.root}>
        <HeaderSlot slot="title">{state.day}</HeaderSlot>
        <div>
          <ReportTitle>
            <FormattedMessage
              id="Logbook.Filling.Steps"
              values={{ current: page, total: LOGBOOK_MAX_PAGE }}
            />{' '}
            -{' '}
            <FormattedMessage
              id={
                page === 1
                  ? 'Logbook.Filling.Title.Review'
                  : page === 2
                  ? 'Logbook.Filling.Title.Information'
                  : 'Logbook.Filling.Title.Signature'
              }
            />
          </ReportTitle>
          <ProgressBar total={LOGBOOK_MAX_PAGE} progress={page} />
        </div>
        {running ? (
          <Fallback />
        ) : (
          <>
            {page === 1 && <Timeline />}
            {page === 2 && <LogbookFormPage />}
            {page === 3 && <Signature />}
          </>
        )}
        {/* <DayOffAlert /> */}
        <HeaderSlot slot="rightContent">
          <CloseButton onClick={() => navigate('/logbook')} />
        </HeaderSlot>
        <HideBotMenu />
      </div>
    </ShellContent>
  );
};

export const SubscribedReport = () => {
  const { result: vehicle } = useVehicle();
  const navigate = useNavigate();

  return (
    <ErrorBoundary
      fallbackRender={({ error }) => {
        let errorMessage = (
          <FormattedMessage id="Logbook.Report.Error.Get" tagName="div" />
        );

        if (error?.response?.status === 403) {
          errorMessage = (
            <FormattedMessage
              id="Logbook.Report.Error.Disabled"
              tagName="div"
              values={{ name: vehicle?.name }}
            />
          );
        }

        return (
          <ShellContent full>
            <div className={styles.root}>
              <PlaceCenter>
                <div className={styles.center}>
                  {errorMessage}
                  <Button variant="text" onClick={() => navigate('/logbook')}>
                    <FormattedMessage id="Back" />
                  </Button>
                </div>
              </PlaceCenter>
              <HeaderSlot slot="rightContent">
                <CloseButton onClick={() => navigate('/logbook')} />
              </HeaderSlot>
              <HideBotMenu />
            </div>
          </ShellContent>
        );
      }}
    >
      <Subscribe fallback={<Fallback />}>
        <Report />
      </Subscribe>
    </ErrorBoundary>
  );
};
